import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: 'HD video clarity & dolby sound',
  description: 'Transform your home into a theatre with premium picture quality and surround sound. Live every moment of what you watch.',
  imageUrl: {
    desktop: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png',
    mobile: 'https://assets.airtel.in/static-assets/airtel-widgets/esim/images/mobile/hero-banner-1.jpg'
  }
}, getTestId('BlogCardWidgetContainer'));